import { currency as baseCurrency } from 'app/src/utils/stringHelpers';

export const currency = amount => {
  if (amount && '0.0' !== amount && '0' !== amount) {
    return baseCurrency(amount.toString().replace(/[^\d\.\-]/g, ''));
  } else {
    return '';
  }
};
